import {
  type KeyboardShortcutActions,
  KeyboardShortcutOptions,
  ShortcutMapping,
  useKeyboardShortcuts,
} from 'hooks/use-keyboard-shortcuts'

/**
 * Hook for page-specific keyboard shortcuts with conflict validation
 *
 * This hook validates that page shortcuts don't conflict with reserved
 * global shortcut keys. In development mode, it will log warnings if
 * conflicts are detected.
 *
 * @param shortcuts - Object mapping key combinations to callback functions
 * @param options - Configuration options for shortcut behavior
 *
 * @example
 * ```tsx
 * usePageKeyboardShortcuts({
 *   '4': () => setLayoutMode('both'),
 *   '5': () => setLayoutMode('table'),
 *   'ctrl+r': () => resetFilters(),
 * }, {
 *   respectInputs: true,
 *   enabled: true
 * })
 * ```
 */
export const usePageKeyboardShortcuts = (
  shortcuts: ShortcutMapping,
  options: KeyboardShortcutOptions = {},
): KeyboardShortcutActions => {
  return useKeyboardShortcuts(shortcuts, options)
}
